
import React, { useState, useEffect, useRef } from 'react';
import Dropdown from "../../assets/dropdown.svg";
import Good from "../../assets/good.svg";

function PermissionInput({ options, label, value, onChange }) {
    const [selectedOption, setSelectedOption] = useState(value);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
        if (selectedOption !== value) {
            setSelectedOption(value);
        }
    }, [selectedOption, value]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsDropdownOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [selectedOption]);

    const handleOptionSelect = (option) => {
        setSelectedOption(option);
        setIsDropdownOpen(false);
        onChange(option);
    };

    return (
        <div className="relative" ref={dropdownRef}>
            <label className="block text-xs sm:text-sm md:text-base font-normal mb-2 mt-8" htmlFor="dropdown">
                {label} (required)
            </label>
            <div className="relative">
                <input
                    id="dropdown"
                    name="dropdown"
                    type="text"
                    value={selectedOption ? selectedOption.label : ''}
                    onFocus={() => setIsDropdownOpen(true)}
                    onBlur={() => setIsDropdownOpen(false)}
                    className="w-full px-3 py-2 pr-10 text-xs md:text-sm border border-border-input rounded-md focus:outline-none focus:ring-2 bg-white shadow-md"
                    placeholder="Select"
                    readOnly
                />
                <div
                    className="absolute inset-y-0 right-0 flex items-center pr-3 cursor-pointer"
                    onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                >
                    <img src={Dropdown} alt="dropdown icon" className="w-2" />
                </div>
            </div>

            {isDropdownOpen && (
                <div className="absolute z-10 w-full bg-white border border-gray rounded-md shadow-md mt-2">
                    {options.map((option) => (
                        <div
                            key={option.value}
                            className={`hover:bg-blue-100 flex items-center justify-between px-3 py-2 cursor-pointer ${selectedOption === option ? 'bg-blue-50 text-enabled-btn' : ''
                                }`}
                            onClick={() => handleOptionSelect(option)}
                        >
                            {option.label}
                            {selectedOption === option && <img src={Good} alt="Good icon" className="w-3 h-3" />}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}

export default PermissionInput;





// new select logic - wasn't working with my addmember modal. left for reference purposes.
// import React, { useState } from 'react';
// import Dropdown from "../../assets/dropdown.svg";
// import Good from "../../assets/good.svg";

// function PermissionInput ({ options, label }) {
//     const [selectedOption, setSelectedOption] = useState(null);
//     const [isDropdownOpen, setIsDropdownOpen] = useState(false);

//     const handleOptionSelect = (option) => {
//         setSelectedOption(option);
//         setIsDropdownOpen(false);
//     };

//     return (
//         <div className="relative">
//             <label className="block text-xs sm:text-sm md:text-base font-normal mb-2 mt-8" htmlFor="dropdown">{label} (required)</label> 
//             <div className="relative">
//                 <input
//                     id="dropdown"
//                     name="dropdown"
//                     type="text"
//                     value={selectedOption ? selectedOption.label : ''}
//                     onFocus={() => setIsDropdownOpen(!isDropdownOpen)}
//                     onBlur={() => setIsDropdownOpen(!isDropdownOpen)}
//                     className="w-full px-3 py-2 pr-10 text-xs md:text-sm border border-border-input rounded-md focus:outline-none focus:ring-2 bg-white shadow-md"
//                     placeholder="Select"
//                 />
//                 <div className="absolute inset-y-0 right-0 flex items-center pr-3 cursor-pointer" onClick={() => setIsDropdownOpen(!isDropdownOpen)}>
//                     <img src={Dropdown} alt="dropdown icon" className="w-2" />
//                 </div>
//             </div>

//             {isDropdownOpen && (
//                 <div className="absolute z-10 w-full bg-white border border-gray rounded-md shadow-md mt-2">
//                     {options.map((option) => (
//                         <div key={option.value}
//                             className={`hover:bg-blue-100 flex items-center justify-between px-3 py-2 cursor-pointer ${selectedOption === option ? 'bg-blue-50 text-enabled-btn' : ''}`}
//                             onClick={() => handleOptionSelect(option)}
//                         >
//                             {option.label}
//                             {selectedOption === option && <img src={Good} alt="Good icon" className="w-3 h-3" />}
//                         </div>
//                     ))}
//                 </div>
//             )}
//         </div>
//     );
// }

// export default PermissionInput;




// First logic
// import React, { useState } from 'react';

// const PermissionInput = ({ label, options, value, onChange }) => {
//     const [isOpen, setIsOpen] = useState(false);
//     const [selectedOption, setSelectedOption] = useState(null);

//     const handleToggle = () => {
//         setIsOpen(!isOpen);
//     };

//     const handleOptionSelect = (option) => {
//         onChange(option);
//         setSelectedOption(option);
//         setIsOpen(false);
//     };

//     return (
//         <div className="relative">
//             <label className="block text-xs sm:text-sm md:text-base font-normal mb-2 mt-8" htmlFor="email">
//                 {label} (required)
//             </label>
//             <div className="relative">
//                 <select
//                     value={selectedOption ? selectedOption.value : ''}
//                     onChange={(e) => {
//                         const selectedValue = e.target.value;
//                         const selectedOption = options.find(
//                             (option) => option.value === selectedValue
//                         );
//                         handleOptionSelect(selectedOption);
//                     }}
//                     onFocus={handleToggle}
//                     onBlur={handleToggle}
//                     className="w-full px-4 py-2 pr-10 text-xs md:text-sm border border-gray rounded-md focus:outline-none focus:ring-2 bg-white shadow-md"
//                 >
//                     <option value="">Select</option>
//                     {options.map((option) => (
//                         <option
//                             key={option.value}
//                             value={option.value}
//                             className={
//                                 selectedOption === option ? 'bg-blue-50 text-enabled-btn' : ''
//                             }
//                         >
//                             {option.label}
//                         </option>
//                     ))}
//                 </select>
//             </div>
//         </div>
//     );
// };

// export default PermissionInput;


// First code
// import React, { useState } from 'react';
// import { DropdownIcon, GoodIcon } from './IconComponents';

// const DropdownInput = ({ label, options, value, onChange }) => {
//     const [isOpen, setIsOpen] = useState(false);
//     const [selectedOption, setSelectedOption] = useState(null);

//     const handleToggle = () => {
//         setIsOpen(!isOpen);
//     };

//     const handleOptionSelect = (option) => {
//         onChange(option);
//         setSelectedOption(option);
//         setIsOpen(false);
//     };

//     return (
//         <div className="relative">
//             <div className="relative">
//                 <label className="block text-xs sm:text-sm md:text-base font-normal mb-2 mt-8" htmlFor="email">
//                     Permission (required)
//                 </label>
//                 <input
//                     type="text"
//                     value={selectedOption ? selectedOption.label : ''}
//                     onChange={(e) => onChange(e.target.value)}
//                     onFocus={handleToggle}
//                     onBlur={handleToggle}
//                     className="w-full px-4 py-2 pr-10 text-xs md:text-sm border border-gray rounded-md focus:outline-none focus:ring-2 bg-white shadow-md"
//                     placeholder="Select"
//                 />
//                 <div
//                     className="absolute inset-y-0 right-0 flex items-center pr-3 cursor-pointer"
//                     onClick={handleToggle}
//                 >
//                     <DropdownIcon className="w-2" />
//                 </div>
//                 {isOpen && (
//                     <ul className="absolute z-10 w-full bg-white border border-gray rounded-md shadow-md">
//                         {options.map((option) => (
//                             <li
//                                 key={option.value}
//                                 className={`flex items-center justify-between px-4 py-2 cursor-pointer ${selectedOption === option ? 'bg-blue-50 text-enabled-btn' : ''
//                                     }`}
//                                 onClick={() => handleOptionSelect(option)}
//                             >
//                                 {option.label}{' '}
//                                 {selectedOption === option && <GoodIcon className="w-3 h-3" />}
//                             </li>
//                         ))}
//                     </ul>
//                 )}
//             </div>
//         </div>
//     );
// };

// export default DropdownInput;



// import React, { useState } from 'react';
// import { DropdownIcon, GoodIcon } from './IconComponents';

// const DropdownInput = ({ label, options, value, onChange }) => {
//     const [isOpen, setIsOpen] = useState(false);
//     const [selectedOption, setSelectedOption] = useState(null);

//     const handleToggle = () => {
//         setIsOpen(!isOpen);
//     };

//     const handleOptionSelect = (option) => {
//         onChange(option);
//         setSelectedOption(option);
//         setIsOpen(false);
//     };

//     return (
//         <div className="relative">
//             <div className="relative">
//                 <input
//                     type="text"
//                     value={selectedOption ? selectedOption.label : ''}
//                     onChange={(e) => onChange(e.target.value)}
//                     onFocus={handleToggle}
//                     onBlur={handleToggle}
//                     className="w-full px-4 py-2 pr-10 text-xs md:text-sm border border-gray rounded-md focus:outline-none focus:ring-2 bg-white shadow-md"
//                     placeholder="Select"
//                 />
//                 <div
//                     className="absolute inset-y-0 right-0 flex items-center pr-3 cursor-pointer"
//                     onClick={handleToggle}
//                 >
//                     <DropdownIcon className="w-2" />
//                 </div>
//                 {isOpen && (
//                     <ul className="absolute z-10 w-full bg-white border border-gray rounded-md shadow-md">
//                         {options.map((option) => (
//                             <li
//                                 key={option.value}
//                                 className={`flex items-center justify-between px-4 py-2 cursor-pointer ${selectedOption === option ? 'bg-blue-50' : ''}`}
//                                 onClick={() => handleOptionSelect(option)}
//                             >
//                                 {option.label} {selectedOption === option && <GoodIcon className="w-3 h-3" />}
//                             </li>
//                         ))}
//                     </ul>
//                 )}
//             </div>
//         </div>
//     );
// };

// export default DropdownInput;
